module.exports = __webpack_public_path__ + "img/ql-bg.527e8f75.png";